import { FC } from 'react';
import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Platforms } from '@wix/ambassador-partners-profile-v1-partner-profile/types';
import ProviderLanguages from '../ProviderLanguages';
import ProviderLocation from '../ProviderLocation';
import ProviderSocialLinks from '../ProviderSocialLinks';
import PlatformDisplay from './PlatformDisplay';

type Props = {
  platforms?: Platforms;
  isMobileView: boolean;
  className?: string;
};

const ContactDetails: FC<Props> = ({ platforms, isMobileView, className }) => {
  const { t } = useTranslation();

  return (
    <Box direction="vertical" className={className}>
      <ProviderLocation showTitle={false} isMobileView={isMobileView} />
      <ProviderLanguages isMobileView={isMobileView} />
      <ProviderSocialLinks />
      <PlatformDisplay
        text={t('profile-page-platforms')}
        platforms={platforms}
        isMobileView={isMobileView}
      />
    </Box>
  );
};

export default ContactDetails;
